import React from 'react';
import { withRouter} from 'react-router-dom';
import { getToken } from '../../store/auth';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Select } from '../inspinia'
import Pagination from "react-js-pagination";

//MASK
import InputMask from 'react-input-mask';
import { CircularProgress } from '@material-ui/core';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_FEATURE_2 } from '../../store/roles';

class ListaLaudo extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            filter: "",
            page: 0,
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },

            form: {
                dataInicio: "",
                dataFim: "",
                filtro: "",
                status: {
                    value: "",
                    label: ""
                },
            },

            downloading: false,
            alerta: withReactContent(Swal),
            process: false,
            buscar: false,

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
            comboStatus: {
                results: undefined
            },
        }

        this.handleBuscarClick = this.handleBuscarClick.bind(this);
        this.handleBuscarInput = this.handleBuscarInput.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadLista = this.loadLista.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
    }

    componentDidMount() {
        this.loadStatus();
    }

    loadStatus() {
        let self = this;
        const url = `${c.API_BASE_URL}/status-carimbo-tempo`;

        const options = {
            method: 'GET'
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboStatus: response });
        });
    }

    handleBuscarInput(e) {
        this.setState({ ...this.state, filter: e.target.value });
    }

    handleBuscarClick() {
        if (this.state.form.dataInicio === "" && this.state.form.dataFim === "") {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar algum filtro de data.");
            return;
        }

        this.setState({ ...this.state, page: 1, buscar: true }, this.loadLista(1, this.state.filter));
    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.loadLista(pageNumber, this.state.filter);
    }

    handleChange(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });

    }

    handleChangeStatus(e) {
        const form = this.state.form;
        this.setState({ form: { ...form, [e.target.name]: { value: e.target.value, label: e.target.options[e.target.selectedIndex].text } } });
    }

    loadLista(pageNumber, filterParam) {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let limit = 10;
        let filter = filterParam === undefined ? "" : filterParam;
        let url = "";

        if (self.state.form.dataInicio == "" && self.state.form.dataFim == "") {
            url = `${c.API_BASE_URL}/laudo?limit=${limit}&page=${page}`;
        } else if (filter == "") {
            url = `${c.API_BASE_URL}/laudo?limit=${limit}&page=${page}&dataInicio=${self.state.form.dataInicio}&dataFim=${self.state.form.dataFim}`;
        } else {
            url = `${c.API_BASE_URL}/laudo?limit=${limit}&page=${page}&dataInicio=${self.state.form.dataInicio}&dataFim=${self.state.form.dataFim}&filtro=${filter}`;
        }

        url = url + `&status=${self.state.form.status.label}`;

        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, list: response })
            if(Array.isArray(response) && response.length === 0) {
                self.setState(prevState => ({list: {...prevState.list, results: []}}));
            }
        });
    }

    getNomeArquivoZip() {
        const dataAtual = new Date();
        const ano = dataAtual.getFullYear();
        const mes = dataAtual.getMonth() + 1;
        const dia = dataAtual.getDate();
        const hora = dataAtual.getHours();
        const min = dataAtual.getMinutes();
        const seg = dataAtual.getSeconds();

        let anoStr = ano.toString();
        let mesStr = mes > 9 ? mes.toString() : "0" + mes.toString();
        let diaStr = dia > 9 ? dia.toString() : "0" + dia.toString();
        let horaStr = hora.toString();
        let minStr = min.toString();
        let segStr = seg.toString();

        return "LAUDOS_ENEL_" + anoStr + mesStr + diaStr + horaStr + minStr + segStr + ".zip";
    }

    render() {
        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-0">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Download Laudo</h3>
                            </Title>

                            <Content>
                                {/* MENU DE OPÇÕES */}
                                <Row className="form-row mb-2">

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Inicio :</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={this.state.form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />

                                    </Column>


                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Fim :</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={this.state.form.dataFim} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>


                                    <Column size="4" className="p-1 mx-auto container">
                                        <label> Pesquisa :</label>
                                        <input type="text" name="search" value={this.state.filter} onChange={this.handleBuscarInput} placeholder="" readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label> Status :</label>
                                        <Select name="status" selected={this.state.form.status.id} data={this.state.comboStatus} onChange={this.handleChangeStatus} placeholder="Status" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container" style={{ marginTop: "30px"}}>
                                        <div className="form-group col-md-1" >
                                            <Button onClick={this.handleBuscarClick} disabled={this.state.process} width="130px">Buscar</Button>
                                        </div>
                                    </Column>
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this} buscar={this.state.buscar} download={this.state.process} />
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-4">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
    
}

class Table extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            selfMain: props.history,
            historyMain: props.history.props.history,
            downloading: false,
            downloadingId: 0
        }
        this.handleDownload = this.handleDownload.bind(this);
    }

    handleDownload(id, nomeArquivoOriginal) {
        this.setState({ ...this.state, downloading: true, downloadingId: id });

        const nomeBase = nomeArquivoOriginal.replace(/\.[^/.]+$/, "");
        const nomeArquivo = nomeBase + ".pdf";

        const url = `${c.API_BASE_URL}/laudo/download?id=${id}&nomeArquivo=${nomeArquivo}`;
        const options = {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                'Content-Type': 'application/json'
            }
        };

        fetch(url, options)
            .then(response => {
                response.blob().then(blob => {
                    const urlFile = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = urlFile;
                    link.target = "_blank";
                    link.setAttribute("download", nomeArquivo);
                    document.body.appendChild(link);
                    link.click();

                    this.setState({ ...this.state, downloading: false, downloadingId: 0 });
                });
            })
            .catch(error => {
                console.error("Erro ao baixar o arquivo:", error);
                this.setState({ ...this.state, downloading: false, downloadingId: 0 });
            });
    }

    render() {
        const data = this.props.data;
        let html = "";

        if (this.props.download) {
            html = (<tr><td colSpan="11" scope="row">Processando download dos arquivos filtrados. Aguarde...</td></tr>);
        }
        else if (!this.props.buscar) {
            html = (<tr><td colSpan="11" scope="row">Inicie a busca preenchendo os filtros e clicando em "Buscar".</td></tr>);
        }
         else if (data.results === undefined) {
            html = (<tr><td colSpan="11" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0) {
            html = (<tr><td colSpan="11" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td className="text-center" style={{width: '70px'}}>{row.id}</td>
                    <td><div style={{wordBreak: 'break-word', width: '190px'}}>{row.nomeMailing}</div></td>
                    <td className="text-center" style={{width: '40px'}}>{row.empresa}</td>
                    <td className="text-center" style={{width: '150px'}}>{row.campanha}</td>
                    <td className="text-center" style={{width: '10px'}}>{row.uc}</td>
                    <td className="text-center" style={{width: '100px'}}>{row.email}</td>
                    <td className="text-center" style={{width: '10px'}}>{row.celular}</td>
                    <TemPermissao permissao = {ROLE_FEATURE_2}>
                    <td className="text-center" style={{width: '10px'}}>{row.nomeToi}</td>
                    </TemPermissao>
                    <td className="text-center" style={{width: '100px'}}>{row.dtInicioCampanha}</td>
                    <td className="text-center" style={{width: '100px'}}>{row.status}</td>
                    <td className="text-center">
                        {this.state.downloading && this.state.downloadingId == row.id ? (
                            <CircularProgress color="inherit"/>
                        ) : (
                            <Button background="transparent" border="none" disabled={this.state.downloading} onClick={() => this.handleDownload(row.id, row.nomeArquivoAnexo)}><Icon name="fa-download" className="mx-1 text-success" /></Button>
                        )
                        }
                    </td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th className="text-center">#</th>
                        <th>Mailing</th>
                        <th className="text-center">Empresa</th>
                        <th className="text-center">Rotina</th>
                        <th className="text-center">UC</th>
                        <th className="text-center">E-mail</th>
                        <th className="text-center">Celular</th>
                        <TemPermissao permissao = {ROLE_FEATURE_2}>
                        <th className="text-center">Nome Toi</th>
                        </TemPermissao>
                        <th className="text-center">Data envio</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaLaudo));
